import { Component, OnInit, Input, Inject, Output, EventEmitter, Optional, OnChanges, signal } from '@angular/core';
import { Observable, of } from 'rxjs';
import {
  CheckSuitabilityDataObj,
  SimpleActivity,
  DataIds,
  ISaveSimpleActivity,
} from '../../../shared/models/activity-dashboard-model';
import { ActivityService } from '../../../core/services/activity.service';
import { SnackbarComponent } from '../../../shared/components/snackbar/snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';

import { FileService } from '../../../core/services/file.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivityDialogComponent } from '../activity-dialog/activity-dialog.component';
// import * as _ from 'lodash'

import {
  ConfirmDialogModel,
  ConfirmDialogComponent,
} from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';

import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'activity-check-suitability',
  templateUrl: './activity-check-suitability.component.html',
  styleUrls: ['./activity-check-suitability.component.scss'],
  standalone: false,
})
export class ActivityCheckSuitabilityComponent implements OnInit, OnChanges {
  // file upload
  allowedTypes = '.doc,docx,.xls,xlsx,.pdf,.jpg,.jpeg,.msg,.png';
  multiple = 'multipleSelect';
  fileDemoData: any;
  single = 'single';
  editId: any;
  fileData: any;
  deletedFile: any;
  existingFileData: any;
  toggleBtn: boolean = false;
  companyHiringType: number = parseInt(localStorage.getItem('fresherCompHiringTypeId'));

  public isCollapsed: boolean = false;

  inputValue: string;
  ids: DataIds;
  notes: string;
  //time
  public timeModifiedOn: string;

  hideNotesAndBtn = false;
  checkActId: any;

  //DNH
  univObj: any;
  dnhBoolean = false;
  disableBtn = true;
  isDeleteDisable: boolean = true;
  hideUpdate: boolean = false;

  // ..
  @Input() checkSuitabilityDataObj: CheckSuitabilityDataObj;
  @Input() candidateApplicationIds: number[];
  @Input() ifCoupled: boolean;
  @Input() selectedCand;
  @Input() candidateDetail: any[];
  loginUserName: string;
  editactivity: boolean = false;
  userloggedin: any;
  @Output() refreshcandiates: EventEmitter<any> = new EventEmitter();
  @Output() singleformValid: EventEmitter<boolean> = new EventEmitter();
  // @Input() dialogRef: MatDialogRef<ActivityDialogComponent>;
  dataSnackbar: any = {
    msg: '',
    isSuccess: false,
  };
  editCheckSuitabilityDataObj: CheckSuitabilityDataObj;
  // proceed_dnh: boolean = true;
  count_dnh: number = 0;
  nh_trueArray: any = [];
  nonDnhList: any = [];
  processStageToUpdate: any;
  displayedColumns: string[] = ['radiobutton', 'organization', 'abbreviated', 'category', 'score'];
  selectedElement: any = [];
  error: boolean;
  error1: boolean;
  toDisplay: boolean;
  checkRAI: boolean = true;
  cleanDNH: boolean;
  expandedEvent: any;
  nonDnhCase: any;
  dnhCase: boolean = false;
  selectedIndex = 0;
  selectedIndexInst = 0;
  selectedIndexUniv = 0;
  fresher: boolean;
  checked1: boolean = false;
  instList = [];
  univList = [];
  errorCode: any;
  disableSubmit: boolean;
  isMapFile = false;

  sendToBgv = signal(false);

  constructor(
    private activityService: ActivityService,
    private _snackBar: MatSnackBar,
    private fileService: FileService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ActivityDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(NgxUiLoaderService) private ngxLoader: NgxUiLoaderService,
  ) {
    if (data) {
      this.checkSuitabilityDataObj = data.checkSuitabilityDataObj;
      this.editactivity = data.editActivity;
      this.isCollapsed = data.editActivity;
      if (data.selectedCandidate) {
        this.selectedCand = data.selectedCandidate;
      }
    }
  }

  ngOnInit() {
    this.notes = '';
    //this.companyHiringType= localStorage.getItem("fresherCompHiringTypeId");

    //this.singleformValid.emit(false);
    this.userloggedin = JSON.parse(localStorage.getItem('loggedInUser'));
    console.log('loginuser---->', this.userloggedin);

    // this.loginUserName=this.userloggedin.attributes.name[0];
    this.loginUserName = this.userloggedin.username;
    console.log(this.loginUserName);

    // this.editId = { objectId: this.checkSuitabilityDataObj.applicationId, objectType: 'AP' };

    console.log(this.editId);
    console.log('hi');
    console.log(this.editactivity);
    if (this.editactivity) {
      console.log(this.checkSuitabilityDataObj);
      this.showMoreLess();
      this.editId = {
        objectId: this.checkSuitabilityDataObj.applicationId,
        objectType: 'AP',
        activityId: this.checkSuitabilityDataObj.activityId,
      };
      this.getActivity(this.checkSuitabilityDataObj);
      // /.applicationId, this.checkSuitabilityDataObj.activityId, this.checkSuitabilityDataObj.processId);
    }

    this.checkActId = this.checkSuitabilityDataObj.activityId;
    if (this.checkActId === '600103') {
      this.hideNotesAndBtn = true;
    }
    this.isMapFile = this.companyHiringType == 1 && this.checkSuitabilityDataObj.activityId == 600104 ? true : false;

    const activityVar: any = this.activityService.dataIds.activityID;
    if (activityVar == '600104' || activityVar == '600105') {
      // if(this.proceed_dnh == true){
      this.dnhCheck();
      console.log('IN HNJ');
      // }
    }
    this.showMoreLess();
  }
  ngOnChanges() {
    this.notes = '';
  }
  testformValid(flag) {
    // console.log('single form working', flag);

    this.singleformValid.emit(flag);
  }

  openSnackBar(message: string) {
    this._snackBar.openFromComponent(SnackbarComponent, {
      data: message,
      duration: 2000,
    });
  }
  // expand/collapse action
  showMoreLess() {
    this.isCollapsed = !this.isCollapsed;
  }
  // validForm(f){
  //   console.log('form value',f);
  //   if(this.notes === null || this.notes==='' ) {
  //     return false;
  //   } else {
  //     return true;
  //   }

  // }

  async activityAction() {
    console.log('this.editactivity', this.editactivity);
    if (this.editactivity) {
      const obj: SimpleActivity = {
        applicationIds: this.checkSuitabilityDataObj.applicationId,
        processID: this.checkSuitabilityDataObj.processId,
        activityID: this.checkSuitabilityDataObj.activityId,
        notes: this.notes,
        createdOn: this.checkSuitabilityDataObj.createdOn,
        createdBy: this.checkSuitabilityDataObj.createdBy,
      };
      this.editActivity(obj);
      this.showMoreLess();
    } else {
      let objS: ISaveSimpleActivity;
      if (this.candidateApplicationIds.length > 0) {
        objS = {
          applicationIds: this.candidateApplicationIds,
          processID: this.checkSuitabilityDataObj.processId,
          activityID: this.checkSuitabilityDataObj.activityId,
          notes: this.notes,
        };
      }
      if (this.checkSuitabilityDataObj.activityId == 600104 || this.checkSuitabilityDataObj.activityId == 600105) {
        try {
          const boolProceedDnh = await this.proceedDNH();
          if (boolProceedDnh) {
            this.saveActivity(objS);
            this.showMoreLess();
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        this.saveActivity(objS);
        this.showMoreLess();
      }
    }
  }
  performAction(obj: any) {
    if (this.checkSuitabilityDataObj.activityId == 100101) {
      const body = {
        applicationIds: obj.applicationIds,
      };
      this.activityService.saveExInfyLog(body).subscribe(
        (response) => {
          console.log(response);
        },
        (error) => {
          console.log(error);
        },
      );
    }
  }
  // Mock function to get data from input field.
  saveActivity(obj: ISaveSimpleActivity, flag?: boolean) {
    console.log('inside save activity of checksuitability');

    this.saveSimpleActivity(obj).subscribe(
      (res: any) => {
        console.log(res);
        if (res?.error && res?.error?.toLowerCase() === 'failure') {
          const data = {
            msg: res.message,
            isSuccess: 'error',
          };
          // this.toDisplay=false

          console.log(data);
          this.activityService.openSnackBar(data, 'danger-snack');
        } else if (
          this.checkSuitabilityDataObj.activityId == 600105 &&
          this.companyHiringType == 1 &&
          flag &&
          res &&
          res?.error == null
        ) {
          const data = {
            msg: res.message,
            isSuccess: 'error',
          };
          console.log(data);
          this.activityService.openSnackBar(data, 'success-snack');
          this.showMoreLess();
          this.refreshcandiates.emit('true');
        } else {
          if (
            (this.checkSuitabilityDataObj.activityId == 600104 || this.checkSuitabilityDataObj.activityId == 600105) &&
            this.univObj.length > 0
          ) {
            console.log(this.univObj);

            const logsArray = this.univObj.map((obj) => {
              const data = obj.selectedElement;
              return {
                organization: obj.nonDNHelement ? (data ? data : null) : data ? data.organization : null,
                abbreviated: obj.nonDNHelement ? null : data ? data.abbreviated : null,
                category: obj.nonDNHelement ? 'Non DNH/Orange/Suspect' : data ? data.category : null,
                score: obj.nonDNHelement ? 0 : data ? data.score : null,
                educationType: obj.educationType,
                dnhInput: obj.nameAsPerRecord,
                dnhResult: obj.dnhOutput,
                sendToBgv: obj.sendToBgv ? 'Y' : 'N',
              };
            });

            const objD = {
              candidateId: this.selectedCand[0].candidateId,
              applicationId: this.checkSuitabilityDataObj.applicationId,
              activityId: Number(this.checkSuitabilityDataObj.activityId),
              dnhOutput: logsArray,
            };
            const cid = this.selectedCand[0].candidateId;
            const appId = this.checkSuitabilityDataObj.applicationId;
            const actId = Number(this.checkSuitabilityDataObj.activityId);
            const dnhCase = this.univObj.find((o) => {
              return o.dnhFlag && o.checkRAI;
            });
            if (dnhCase) {
              this.activityService.setDnhReject(actId, cid, appId).subscribe(
                (res) => {
                  console.log(res);
                  if (res && res.toLowerCase().includes('successfully')) {
                    const sata6 = {
                      msg: 'Organization(s) is part of DNH list, so offer cannot be proposed and RAI will be performed on current application',
                      isSuccess: true,
                    };
                    if (String(this.checkSuitabilityDataObj.activityId) == '600104') {
                      sata6.msg =
                        'University(s) is part of DNH list, so offer cannot be proposed and RAI will be performed on current application';
                    }
                    this.activityService.openSnackBar(sata6, 'success-snack');
                    this.refreshcandiates.emit('true');
                  } else {
                    const sata7 = {
                      msg: res,
                      isSuccess: false,
                    };
                    this.activityService.openSnackBar(sata7, 'success-snack');
                  }
                },
                (err) => {
                  const data1 = {
                    msg: 'Some error occurred',
                    isSuccess: false,
                  };
                  this.activityService.openSnackBar(data1, 'danger-snack');
                  console.log('err-->', err);
                },
              );
            }
            if (objD.dnhOutput.length > 0) {
              this.ngxLoader.start();
              this.activityService.dnhLogs(objD).subscribe(
                (_res) => {
                  if (this.sendToBgv()) {
                    const data = {
                      msg: "Send Successfully",
                      isSuccess: true,
                    };
                    console.log(data);
                    this.activityService.openSnackBar(data, 'success-snack');
                  }
                  this.ngxLoader.stop();
                },
                (err) => {
                  console.log('err-->', err);
                  this.ngxLoader.stop();
                },
              );
            }
          }
          this.performAction(obj);
          if (this.isMapFile) {
            this.fileService.saveAttachmentMultiple(
              this.checkSuitabilityDataObj.applicationId,
              this.companyHiringType,
              this.fileData,
              this.deletedFile,
              this.checkSuitabilityDataObj.activityId,
            );
          } else {
            this.saveAttachment(this.checkSuitabilityDataObj.applicationId, this.companyHiringType);
          }
          console.log('snackbar if in ts');
          if(res?.message){
            const data = {
              msg: res.message,
              isSuccess: 'created',
            };
            console.log(data);
            this.activityService.openSnackBar(data, 'success-snack');
          }          
          let dnhCase;
          if (this.checkSuitabilityDataObj.activityId == 600104 || this.checkSuitabilityDataObj.activityId == 600105) {
            dnhCase = this.univObj.find((o) => {
              return o.dnhFlag && o.checkRAI;
            });
          }
          if (!this.ifCoupled && !dnhCase) {
            this.refreshcandiates.emit('true');
          }
        }
      },
      (err) => {
        const data1 = {
          msg: 'Some error occurred',
          isSuccess: false,
        };
        this.activityService.openSnackBar(data1, 'danger-snack');
        console.log('err-->', err);
      },
    );
  }

  saveSimpleActivity(obj: ISaveSimpleActivity): Observable<any> {
    const isDnhActivity =
      this.checkSuitabilityDataObj.activityId == 600104 || this.checkSuitabilityDataObj.activityId == 600105;
    const sendToBgv = isDnhActivity && (this.univObj || []).some((o) => o.sendToBgv);
    if (sendToBgv) {
      // skip the save simple activity call; emit null so downstream handling still runs without a response
      return of(null);
    }
    return this.activityService.saveSimpleActivity(obj);
  }

  editActivity(editObj: SimpleActivity) {
    //console.log('inside edit activity',editObj);
    this.activityService.editSimpleActivity(editObj).subscribe(
      (res: string) => {
        console.log('response' + res);
        if (this.isMapFile) {
          this.fileService.saveAttachmentMultiple(
            this.checkSuitabilityDataObj.applicationId,
            this.companyHiringType,
            this.fileData,
            this.deletedFile,
            this.checkSuitabilityDataObj.activityId,
          );
        } else {
          this.saveAttachment(this.checkSuitabilityDataObj.applicationId, this.companyHiringType);
        }
        const data = {
          msg: 'Data Updated Successfully !!!',
          isSuccess: true,
        };

        this.activityService.openSnackBar(data, 'success-snack');
        this.performAction(editObj);
      },
      (_err) => {
        const data = {
          msg: 'Some error Occurred',
          isSuccess: false,
        };

        this.activityService.openSnackBar(data, 'danger-snack');
      },
    );
    this.dialogRef.close();
  }

  getActivity(obj: CheckSuitabilityDataObj) {
    console.log('indide get activity function in component');
    console.log(this.ids);

    this.activityService
      .getSimpleActivity(obj.applicationId, obj.activityId, obj.processId, obj.createdOn)
      .subscribe((response: SimpleActivity) => {
        this.checkSuitabilityDataObj.simpleActivity = response;
        console.log(response);
        this.dataInitialization(response);
      });
  }

  dataInitialization(activityObj: SimpleActivity) {
    console.log(activityObj);
    if (activityObj.notes === null) {
      this.notes = '';
      this.isDeleteDisable = true;
      console.log('IF_inside dataInitialization' + this.isDeleteDisable);
    } else {
      //console.log('form vlaue notes',f.value.notes);
      this.notes = activityObj.notes;
      // time
      this.timeModifiedOn = activityObj.modifiedOn;
      this.isDeleteDisable = false;
      console.log('ELSE_inside dataInitialization' + this.isDeleteDisable);
    }
  }

  deleteActivity() {}

  // file upload
  receiveFileOutput(filedata) {
    // setTimeout(() => {
    console.log('inside recievefile format');
    this.fileData = filedata['fileMerge1'];
    this.deletedFile = filedata['deletedFile1'];
    console.log(this.fileData);
    console.log(this.deletedFile);

    if (this.fileData.length > 0) {
      if (this.error1) {
        if (this.companyHiringType == 4 && this.checkSuitabilityDataObj.activityId == 600105) {
          if (this.checked1 == true) {
            console.log('inside length checked1');
            this.disableBtn = false;
          } else {
            this.disableBtn = true;
          }
        }
      } else {
        this.disableBtn = false;
        console.log('something');
      }
    }
    if (this.deletedFile.length > 0) {
      const attachFlag = this.univObj.find((ele) => {
        return ele.attachmentFlag;
      });
      if (this.fileData.length == 0 && attachFlag) {
        this.disableBtn = true;
        console.log('inside deleted');
      } else {
        this.disableBtn = false;
      }
    }
    if (this.fileData.length == 0) {
      console.log('nothing');
      if (this.error1) {
        if (this.companyHiringType == 4 && this.checkSuitabilityDataObj.activityId == 600105) {
          if (this.checked1 == true) {
            console.log('inside nothing phone 1');
            this.disableBtn = false;
          } else {
            this.disableBtn = true;
          }
        }
      } else {
        const attachFlag = this.univObj.find((ele) => {
          return ele.attachmentFlag;
        });
        if (attachFlag) {
          this.disableBtn = true;
        } else {
          this.disableBtn = false;
        }
      }
    }
    // }, 3000);
    if (this.checkSuitabilityDataObj.activityId == 600104 && this.companyHiringType == 1) {
      const attachFlag = this.univObj.find((ele) => {
        return ele.attachmentFlag;
      });
      const errorCode1 = this.fileData.find((f) => f && f.attachmentId == 117);
      const errorCode2 = this.fileData.find((f) => f && f.attachmentId == 115);
      const has293 = this.fileData.some((f) => f && Number(f.attachmentId) == 293);
      if (attachFlag && this.errorCode == 0) {
        this.disableBtn = !has293;
      } else if (attachFlag && this.errorCode == 1) {
        this.disableBtn = !(has293 && errorCode1);
      } else if (attachFlag && this.errorCode == 2) {
        this.disableBtn = !(has293 && errorCode1 && errorCode2);
      } else if (!attachFlag && this.errorCode == 0) {
        this.disableBtn = false;
      } else if (!attachFlag && this.errorCode == 1) {
        this.disableBtn = !errorCode1;
      } else if (!attachFlag && this.errorCode == 2) {
        this.disableBtn = !(errorCode1 && errorCode2);
      }
    }
  }

  recieveExistingFile(filedata) {
    console.log('filedata in recieve', filedata);

    this.existingFileData = filedata['existingFileArray'];
    console.log(this.existingFileData);
  }

  saveAttachment(genericId, companyHiringTypeId) {
    console.log('inside saveattachmnt suitability');
    if (this.deletedFile && this.deletedFile.length > 0) {
      this.deletedFile.forEach((file) => {
        this.fileService.deleteFile(file.fileID).subscribe(
          (_res) => {},
          (_err) => {
            const data = {
              msg: 'Some error Occurred',
              isSuccess: false,
            };
            this.activityService.openSnackBar(data, 'danger-snack');
          },
        );
      });
    }
    const activityId: any = this.checkSuitabilityDataObj.activityId;
    const fd = new FormData();
    fd.append('objectId', genericId);
    fd.append('objectType', 'AP');
    fd.append('attachmentId', '2');
    fd.append('companyHiringTypeId', companyHiringTypeId);
    fd.append('activityId', activityId);
    if (this.fileData && this.fileData.length > 0) {
      this.fileData.forEach((file) => {
        fd.append('file[' + file.name + ']', file);
      });
      console.log(fd);
      this.fileService.upload(fd).subscribe(
        (_res) => {},
        (_err) => {},
      );
    }
  }

  dnhCheck() {
    this.nh_trueArray.splice(0, this.nh_trueArray.length);
    this.nonDnhList.splice(0, this.nonDnhList.length);
    const cand = this.selectedCand[0].candidateId;

    if (this.count_dnh === 0) {
      this.activityService.getDnhType(cand).subscribe(
        (res1) => {
          this.errorCode = res1.errorCode;
          this.univObj = res1.doNotHireCheckData;
          if (this.checkSuitabilityDataObj.activityId == 600104) {
            this.instList = res1.doNotHireCheckData.filter((list) => {
              return list.type && list.type.toLowerCase() == 'institute';
            });
            this.univList = res1.doNotHireCheckData.filter((list) => {
              return list.type && list.type.toLowerCase() == 'university';
            });
          }
          console.log(this.univObj);
          if (this.univObj.length > 0) {
            const noData = this.univObj.find((univ) => {
              return univ.nameAsPerRecord == null && univ.dnhOutput == null;
            });
            if (noData) {
              const sata3 = {
                msg: 'Organization details of candidate not present',
                isSuccess: false,
              };
              if (this.checkSuitabilityDataObj.activityId == 600104) {
                sata3.msg = 'Education details of candidate not present';
              }
              this.activityService.openSnackBar(sata3, 'danger-snack');
              this.error1 = true;
              if (this.companyHiringType == 4 && this.checkSuitabilityDataObj.activityId == 600105) {
                this.fresher = true;
              }
            } else {
              this.expandedEvent = this.univObj[0].nameAsPerRecord;
              const scoreArray = ['100', '100.0', '100.00'];
              this.univObj.forEach((ele, index) => {
                const dnhObj = ele.dnhOutput.find((output) => {
                  return output.category.toLowerCase().includes('dnh') && scoreArray.indexOf(output.score) != -1;
                });
                console.log(dnhObj);
                if (dnhObj) {
                  ele['dnhFlag'] = true;
                  ele['selectedElement'] = dnhObj;
                  ele['attachmentFlag'] = false;
                  ele['nonDNHelement'] = false;
                  ele['checkRAI'] = true;
                  ele['uniq'] = index;
                  ele['sendToBgv'] = false;
                  this.disableBtn = false;
                } else {
                  ele['dnhFlag'] = false;
                  ele['selectedElement'] = undefined;
                  ele['attachmentFlag'] = true;
                  ele['nonDNHelement'] = false;
                  ele['checkRAI'] = false;
                  ele['uniq'] = index;
                  ele['sendToBgv'] = false;
                }
              });
              console.log(this.univObj);
              const dnh = this.univObj.find((o) => {
                return o.dnhFlag && o.checkRAI;
              });
              this.dnhCase = dnh ? true : false;
            }
          } else {
            const sata = {
              msg: 'Organization(s) is not a part of DNH List',
              isSuccess: true,
            };
            if (String(this.checkSuitabilityDataObj.activityId) == '600104') {
              sata.msg = 'University(s) and Institute(s) are not a part of DNH List';
            }
            this.activityService.openSnackBar(sata, 'success-snack');
            this.error = true;
            this.disableBtn = false;
            this.nonDnhCase = true;
          }
          if (res1.errorCode == 1 || res1.errorCode == 2) {
            this.disableBtn = true;
            if (!(this.checkSuitabilityDataObj.activityId == 600104 && this.data && this.data.readFlag)) {
              const dnhMessageDialog = new ConfirmDialogModel('Warning!', res1.message);
              this.dialog.open(ConfirmDialogComponent, { maxWidth: '400px', data: dnhMessageDialog });
            }
          }
        },
        (err) => {
          const data1 = {
            msg: 'Some error occurred',
            isSuccess: false,
          };
          this.activityService.openSnackBar(data1, 'danger-snack');
          console.log('err-->', err);
          this.dnhBoolean = false;
          this.disableBtn = true;
        },
      );
    }

    this.count_dnh = 1;
    // console.log(this.nh_trueArray);
  }
  radiobuttonChange(element, nonDNHcheck, nameAsPerRecord, uniqInd, type, event?) {
    if (this.checkSuitabilityDataObj.activityId == 600104) {
      if (type == 'institute') {
        uniqInd = this.instList[uniqInd].uniq;
      } else {
        uniqInd = this.univList[uniqInd].uniq;
      }
    }
    const obj = this.univObj.find((ele) => {
      return ele.nameAsPerRecord == nameAsPerRecord && ele.uniq == uniqInd;
    });
    if (nonDNHcheck) {
      obj.nonDNHelement = true;
      obj.attachmentFlag = false;
      obj.sendToBgv = false;
    } else {
      obj.nonDNHelement = false;
      obj.attachmentFlag = true;
    }
    // let scoreArray = ['100', '100.0', '100.00'];
    if (!event || (event && event.checked)) {
      obj.selectedElement = element;
    } else {
      obj.selectedElement = undefined;
      obj.nonDNHelement = false;
      obj.attachmentFlag = true;
      obj.sendToBgv = false;
    }
    this.sendToBgv.set(this.univObj.some((o) => o.sendToBgv));
    if (event && nonDNHcheck) {
      if (event.checked) {
        this.disableBtn = false;
      }
    }
    const dnhCase = this.univObj.find((o) => {
      return o.dnhFlag && o.checkRAI;
    });
    const attachFlag = this.univObj.find((ele) => {
      return ele.attachmentFlag;
    });
    if (attachFlag && (!this.fileData || (this.fileData && this.fileData.length < 1)) && !dnhCase) {
      this.disableBtn = true;
    }
    if (this.checkSuitabilityDataObj.activityId == 600104 && this.companyHiringType == 1) {
      if (attachFlag) {
        const has293 = this.fileData && this.fileData.some(f => f && Number(f.attachmentId) == 293);
        const errorCode1 = this.fileData && this.fileData.find(f => f && f.attachmentId == 117);
        const errorCode2 = this.fileData && this.fileData.find(f => f && f.attachmentId == 115);
        if (this.errorCode == 0) {
          this.disableBtn = !has293;
        } else if (this.errorCode == 1) {
          this.disableBtn = !(has293 && errorCode1);
        } else if (this.errorCode == 2) {
          this.disableBtn = !(has293 && errorCode1 && errorCode2);
        }
      }
    }
    console.log(element, this.univObj);
  }

  toggleSendToBgv(univ: any, event: any) {
    // univ.sendToBgv = event.checked;
    this.univObj = this.univObj.map((o) => {
      if(univ && o === univ) {
        o.sendToBgv = event.checked;
      }
      return o;
    });

    const dnhCase = this.univObj.find((o) => o.dnhFlag && o.checkRAI);
    const attachFlag = this.univObj.find((ele) => ele.attachmentFlag);
    const bgvPending = this.univObj.some((o) => o.attachmentFlag && !o.sendToBgv);
    const sendToBgv = this.univObj.some((o) => o.sendToBgv);
    this.sendToBgv.set(sendToBgv);
    if (attachFlag && !dnhCase) {
      this.disableBtn = (bgvPending || !this.fileData || this.fileData.length < 1);
    }
  }

  changeRAI() {
    let dnhDataCase = true;
    const dnhCase = this.univObj
      .filter((o) => {
        return o.dnhFlag && o.checkRAI;
      })
      .map((obj) => {
        return obj.nameAsPerRecord;
      });
    if (dnhCase && dnhCase.length > 0) {
      dnhDataCase = true;
      this.activityService.openSnackBar({ msg: dnhCase + ' are all the DNH cases', isSuccess: false }, 'success-snack');
    } else {
      dnhDataCase = false;
    }
    this.univObj.forEach((element) => {
      if (element.dnhFlag) {
        element.checkRAI = !element.checkRAI;
        element.attachmentFlag = !element.attachmentFlag;
      }
    });
    if ((this.fileData && this.fileData.length > 0 && dnhDataCase) || !dnhDataCase) {
      this.disableBtn = false;
    } else {
      this.disableBtn = true;
    }
  }

  changeFresher(event?) {
    if (event.checked) {
      this.checked1 = true;
      this.notes = 'Fresher';
      this.disableBtn = false;
    } else {
      this.notes = '';
      this.disableBtn = true;
      this.checked1 = false;
    }
  }

  eventHandler(_ev) {
    this.showMoreLess();
    const data = {
      msg: 'Updated Successfully !!!',
      isSuccess: true,
    };
    this.activityService.openSnackBar(data, 'success-snack');
    this.refreshcandiates.emit('true');
  }

  destroyCard(_eve) {
    this.hideUpdate = true;
  }

  async proceedDNH() {
    return new Promise((resolve, reject) => {
      if (this.nonDnhCase) {
        return resolve(true);
      }
      const noData = this.univObj.find((univ) => {
        return univ.nameAsPerRecord == null && univ.dnhOutput == null;
      });
      if (this.companyHiringType == 4 && this.checkSuitabilityDataObj.activityId == 600105 && noData) {
        return resolve(true);
      }
      const dnhCase = this.univObj.find((o) => {
        return o.dnhFlag && o.checkRAI;
      });
      const selectedElements = this.univObj.find((se) => {
        return !se.selectedElement;
      });
      if (!dnhCase && selectedElements && !this.sendToBgv()) {
        this.expandedEvent = selectedElements.nameAsPerRecord;
        this.selectedIndex = selectedElements.uniq;
        let selectAllMsg = 'Please select all Organizations';
        if (this.checkSuitabilityDataObj.activityId == 600104) {
          selectAllMsg = 'Please select all Universities & Institutes';
          if (selectedElements.type && selectedElements.type.toLowerCase() == 'institute') {
            this.selectedIndexInst = this.instList.indexOf(selectedElements);
          } else {
            this.selectedIndexUniv = this.univList.indexOf(selectedElements);
          }
        }
        this.activityService.openSnackBar({ msg: selectAllMsg, isSuccess: false }, 'danger-snack');
        return reject(false);
      }
      const nonDnhOrgs = this.univObj
        .filter((org) => {
          return org.nonDNHelement;
        })
        .map((obj) => {
          return obj.selectedElement;
        });
      if (nonDnhOrgs && nonDnhOrgs.length > 0) {
        const dnhMsg = "Are you sure '" + nonDnhOrgs + "' is not a DNH/Suspect/Orange?";
        const dnhDialogData = new ConfirmDialogModel(dnhMsg, '');
        const dnhDialogRef = this.dialog.open(ConfirmDialogComponent, { maxWidth: '400px', data: dnhDialogData });
        dnhDialogRef.afterClosed().subscribe((dnhDialogResult) => {
          if (dnhDialogResult) {
            return resolve(true);
          }
        });
      } else if (dnhCase && nonDnhOrgs.length == 0) {
        return resolve(true);
      } else if (!selectedElements || this.sendToBgv()) {
        return resolve(true);
      }
    });
  }

  checkForDisabled(f: any) {
    // BGV review skips every other check
    return this.sendToBgv() ? false : f.invalid || this.disableBtn;
  }
}
